import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import useAPI from '@/hooks/useAPI';
import { scheduleExpectationRepository } from '@/repositories/ScheduleExpectationRepository';

/** Custom expectations on a phase that have not ended yet, including upcoming ones. */
export const useOpenCustomScheduleExpectations = (phaseId: string | null | undefined) => {
  const { host } = useContext(AppContext);

  return useAPI({
    queryKey: ['getOpenCustomScheduleExpectations', phaseId],
    queryFn: async () =>
      await scheduleExpectationRepository.listOpenCustomScheduleExpectations({
        host,
        phaseId: phaseId!
      }),
    enabled: Boolean(phaseId)
  });
};

export default useOpenCustomScheduleExpectations;
